
import { Component, OnInit, ViewChild } from '@angular/core';
import { LegendLabelsContentArgs } from "@progress/kendo-angular-charts";
import { State, AggregateDescriptor, SortDescriptor, CompositeFilterDescriptor, orderBy, filterBy } from "@progress/kendo-data-query";
import { CoreHelperService } from 'src/app/providers/core-helper/core-helper.service';
import { formatNumber } from '@progress/kendo-angular-intl';
import { lastValueFrom } from 'rxjs';
import { ReportService } from 'src/app/modules/auth/report/report.service';
import { Router } from '@angular/router';
import { CommonVobReportService } from './common-vob-report.service';
import { CommonPageService } from 'src/app/shared/utility/common-page.service';
import { GridComponent, PageChangeEvent } from '@progress/kendo-angular-grid';
import { UserManagementService } from 'src/app/modules/auth/administration/user-management/user-management.service';
import { ModuleTabIds } from '../../enum/module-tab-master';
import { VOBService } from 'src/app/modules/auth/services/vob.service';
import { DynamicListData } from '../../DynamicListData';
import { AdministrationService } from 'src/app/modules/auth/administration/administration.service';
import { DropdownListRequestModel, DropdownType } from 'src/app/modules/auth/administration/administration.classes ';

@Component({
  selector: 'app-vob-report',
  templateUrl: './common-vob-report.component.html',
})
export class CommonVobReportComponent implements OnInit {
  facilityPayerList = DynamicListData.FacilityPayerList;
  range = { start: null, end: null };
  dateValue: Date = new Date();
  reportName: string;
  dailyProductionReportGridData: any[] = [];
  qualityReportGridData: any[] = [];
  callTimeReportGridData: any[] = [];
  tatReportGridData: any[] = [];
  specialistBreakReportGridData: any[] = [];
  showCalender = false;
  selectFacilityList: any[] = [];
  vobSpecialistList: any[] = [];
  selectedFacility: any[] = [];
  selectedVobSpecialist: any[] = [];
  isCheckedFacility = true;
  isCheckedSpecialist = true;
  isSelected: boolean = false;
  selectedMonthss = "This Month";
  permissionList: any = [];
  isDailyProductionReport: boolean = false;
  isQualityReport: boolean = false;
  isCallTimeReport: boolean = false;
  isTATReport: boolean = false;
  isSpecialistBreakReport: boolean = false;
  isVobVolumeReport: boolean = false;
  isReAssignReport: boolean = false;
  isMissingInformationReport: boolean = false;
  isFacilityPayerReport: boolean = false;
  isSpecialistPerformanceReport: boolean = false;
  selectedFacilityPayerId: number = 0;
  selectPayerList: any[] = [];
  selectedPayer: any[] = [];
  isCheckedPayer = true;
  @ViewChild("dailyProductionReportGrid") public dailyProductionReportGrid: GridComponent;
  @ViewChild("qualityReportGrid") public qualityReportGrid: GridComponent;
  @ViewChild("callTimeReportGrid") public callTimeReportGrid: GridComponent;
  @ViewChild("tatReportGrid") public tatReportGrid: GridComponent;
  @ViewChild("specialistBreakReportGrid") public specialistBreakReportGrid: GridComponent;
  @ViewChild("vobVolumeReportGrid") public vobVolumeReportGrid: GridComponent;
  @ViewChild("reAssignReportGrid") public reAssignReportGrid: GridComponent;
  public showVobDetailHistory: boolean = false;
  public detailedHistoryList: any[] = [];
  @ViewChild("missingInformationReportGrid") public missingInformationReportGrid: GridComponent;
  @ViewChild("facilityPayerReportGrid") public facilityPayerReportGrid: GridComponent;
  @ViewChild("specialistPerformanceReportGrid") public specialistPerformanceReportGrid: GridComponent;

  constructor(
    private _router: Router,
    public coreHelperService: CoreHelperService,
    public _reportService: ReportService,
    public _commonPageService: CommonPageService,
    private _userManagementService: UserManagementService,
    private _vobService: VOBService,
    private _administrationService: AdministrationService,
    public _commonVobReportService: CommonVobReportService) {
    this.loadPermission();
    this.range.start = new Date();
    this.range.start.setDate(this.range.start.getDate() - 1);
    this.range.end = new Date();
  }

  //#region Permission Changes
  isDailyProductionReportExportAllowed: boolean = false;
  isQualityReportExportAllowed: boolean = false;
  isCallTimeReportExportAllowed: boolean = false;
  isTATReportExportAllowed: boolean = false;
  isSpecialistBreakReportExportAllowed: boolean = false;
  isVobVolumeReportAllowed: boolean = false;
  isReAssignReportAllowed: boolean = false;
  isMissingInformationReportAllowed: boolean = false;
  isFacilityPayerReportAllowed: boolean = false;
  isSpecialistPerformanceReportAllowed: boolean = false;

  loadPermission() {
    this.permissionList = this.coreHelperService.getVOBReportTabsPermission();
    if (this.permissionList != undefined && this.permissionList.length > 0) {
      let reports = this.permissionList.filter(r => r.tabMasterId == ModuleTabIds.Daily_Production_Report && r.moduleElementTransId == 0 && r.isEdit > 0);
      this.isDailyProductionReportExportAllowed = (reports != undefined && reports != null && reports.length > 0);
    }
    if (this.permissionList != undefined && this.permissionList.length > 0) {
      let reports = this.permissionList.filter(r => r.tabMasterId == ModuleTabIds.Quality_Report && r.moduleElementTransId == 0 && r.isEdit > 0);
      this.isQualityReportExportAllowed = (reports != undefined && reports != null && reports.length > 0);
    }
    if (this.permissionList != undefined && this.permissionList.length > 0) {
      let reports = this.permissionList.filter(r => r.tabMasterId == ModuleTabIds.Call_Time_Report && r.moduleElementTransId == 0 && r.isEdit > 0);
      this.isCallTimeReportExportAllowed = (reports != undefined && reports != null && reports.length > 0);
    }
    if (this.permissionList != undefined && this.permissionList.length > 0) {
      let reports = this.permissionList.filter(r => r.tabMasterId == ModuleTabIds.TAT_Report && r.moduleElementTransId == 0 && r.isEdit > 0);
      this.isTATReportExportAllowed = (reports != undefined && reports != null && reports.length > 0);
    }
    if (this.permissionList != undefined && this.permissionList.length > 0) {
      let reports = this.permissionList.filter(r => r.tabMasterId == ModuleTabIds.Specialist_Break_Report && r.moduleElementTransId == 0 && r.isEdit > 0);
      this.isSpecialistBreakReportExportAllowed = (reports != undefined && reports != null && reports.length > 0);
    }
    if (this.permissionList != undefined && this.permissionList.length > 0) {
      let reports = this.permissionList.filter(r => r.tabMasterId == ModuleTabIds.Volume_Report && r.moduleElementTransId == 0 && r.isEdit > 0);
      this.isVobVolumeReportAllowed = (reports != undefined && reports != null && reports.length > 0);
    }
    if (this.permissionList != undefined && this.permissionList.length > 0) {
      let reports = this.permissionList.filter(r => r.tabMasterId == ModuleTabIds.ReAssign_Report && r.moduleElementTransId == 0 && r.isEdit > 0);
      this.isReAssignReportAllowed = (reports != undefined && reports != null && reports.length > 0);
    }
    if (this.permissionList != undefined && this.permissionList.length > 0) {
      let reports = this.permissionList.filter(r => r.tabMasterId == ModuleTabIds.Missing_Info_Report && r.moduleElementTransId == 0 && r.isEdit > 0);
      this.isMissingInformationReportAllowed = (reports != undefined && reports != null && reports.length > 0);
    }
    if (this.permissionList != undefined && this.permissionList.length > 0) {
      let reports = this.permissionList.filter(r => r.tabMasterId == ModuleTabIds.Facility_Payer_Report && r.moduleElementTransId == 0 && r.isEdit > 0);
      this.isFacilityPayerReportAllowed = (reports != undefined && reports != null && reports.length > 0);
    }
    if (this.permissionList != undefined && this.permissionList.length > 0) {
      let reports = this.permissionList.filter(r => r.tabMasterId == ModuleTabIds.Specialist_Performance_Report && r.moduleElementTransId == 0 && r.isEdit > 0);
      this.isSpecialistPerformanceReportAllowed = (reports != undefined && reports != null && reports.length > 0);
    }
  }
  //#endregion

  ngOnInit(): void {
    let currentUrl = this._router.url;

    this.selectedFacilityPayerId = 0;
    if (currentUrl.includes('daily-production-report')) {
      this.reportName = "Daily Production Report";
      this.isDailyProductionReport = true;
    } else if (currentUrl.includes('quality-report')) {
      this.reportName = "Quality Report";
      this.isQualityReport = true;
    } else if (currentUrl.includes('call-metrics-report')) {
      this.reportName = "Call Metrics Report";
      this.isCallTimeReport = true;
    } else if (currentUrl.includes('tat-report')) {
      this.reportName = "TAT Report";
      this.isTATReport = true;
    } else if (currentUrl.includes('specialist-break-report')) {
      this.reportName = "Specialist Break Report";
      this.isSpecialistBreakReport = true;
    } else if (currentUrl.includes('volume-report')) {
      this.reportName = "Volume Report";
      this.isVobVolumeReport = true;
    } else if (currentUrl.includes('reassign-report')) {
      this.reportName = "ReAssign Or Rework Report";
      this.isReAssignReport = true;
    } else if (currentUrl.includes('missing-information-report')) {
      this.reportName = "Missing Information Report";
      this.isMissingInformationReport = true;
    } else if (currentUrl.includes('facility-payer-report')) {
      this.reportName = "Facility/Payer Report";
      this.isFacilityPayerReport = true;
      this.selectedFacilityPayerId = DynamicListData.FacilityPayerList[0].value;
    } else if (currentUrl.includes('specialist-performance-report')) {
      this.reportName = "Specialist Performance Report";
      this.isSpecialistPerformanceReport = true;
    }
    this._commonPageService.clearGroupPaginationListDataCommon();
    this._commonPageService.clearCommonState();
    this.range.start = this.coreHelperService.getMonthStartDate().toISOString();
    this.range.end = this.coreHelperService.getMonthEndDate().toISOString();
    this.getFacilityForFilter();
  }

  // Page Title
  public get isIndetFacility() {
    return this.selectedFacility.length !== 0 && this.selectedFacility.length !== this.selectFacilityList.length;
  }
  public get isIndetSpecialist() {
    return this.selectedVobSpecialist.length !== 0 && this.selectedVobSpecialist.length !== this.vobSpecialistList.length;
  }
  public get isIndetPayer() {
    return this.selectedPayer.length !== 0 && this.selectedPayer.length !== this.selectPayerList.length;
  }
  public get toggleAllTextFacility() {
    return this.isCheckedFacility ? 'Deselect All' : 'Select All';
  }
  public get toggleAllTextSpecialist() {
    return this.isCheckedSpecialist ? 'Deselect All' : 'Select All';
  }
  public get toggleAllTextPayer() {
    return this.isCheckedPayer ? 'Deselect All' : 'Select All';
  }
  public isFacilityItemSelected(item) {
    return this.selectedFacility.some((x) => x.facilityId === item.facilityId);
  }
  public isSpecialistItemSelected(item) {
    return this.selectedFacility.some((x) => x.facilityId === item.facilityId);
  }
  public isPayerItemSelected(item) {
    return this.selectedPayer.some((x) => x.value === item.value);
  }
  public onClickFacility() {
    this.isCheckedFacility = !this.isCheckedFacility;
    this.selectedFacility = this.isCheckedFacility ? this.selectFacilityList.slice() : [];
  }
  public onClickSpecialist() {
    this.isCheckedSpecialist = !this.isCheckedSpecialist;
    this.selectedVobSpecialist = this.isCheckedSpecialist ? this.vobSpecialistList.slice() : [];
  }
  public onClickPayer() {
    this.isCheckedPayer = !this.isCheckedPayer;
    this.selectedPayer = this.isCheckedPayer ? this.selectPayerList.slice() : [];
  }
  public onValueChangeFacility() {
    this.isCheckedFacility = this.selectedFacility.length === this.selectFacilityList.length;
  }
  public onValueChangeSpecialist() {
    this.isCheckedSpecialist = this.selectedVobSpecialist.length === this.vobSpecialistList.length;
  }

  public onValueChangePayer() {
    this.isCheckedPayer = this.selectedPayer.length === this.selectPayerList.length;
  }

  getReportRequestModel() {
    this.isSelected = false;
    if (this.selectedFacility?.length == 0 || this.selectedVobSpecialist?.length == 0 || this.selectedPayer?.length == 0) {
      this.isSelected = true;
      return null;
    }
    let facilityIds = [];
    this.selectedFacility.forEach(element => {
      facilityIds.push(element.facilityId)
    });
    let specialistIds = [];
    this.selectedVobSpecialist.forEach(element => {
      specialistIds.push(element.userId)
    });
    let payerIds = [];
    this.selectedPayer.forEach(element => {
      payerIds.push(element.value)
    });
    let requestModel = {
      facilityIds: this.coreHelperService.getLoggedInUserDomain() == 1 ? this.coreHelperService.getLoggedInUserDetail().isMultipleFacility == 0 ? this.coreHelperService.getFacilityId().toString() :
        facilityIds.toString() : facilityIds.toString(),
      specialistIds: specialistIds.toString(),
      payerIds: payerIds.toString(),
      reportType: this.selectedFacilityPayerId,
      fromServiceDate: this.coreHelperService.getUtcDate(new Date(this.range.start)),
      toServiceDate: this.coreHelperService.getUtcDate(new Date(this.range.end))
    }
    return requestModel;
  }

  runReport() {
    this._commonPageService.clearGroupPaginationListDataCommon();
    if (this.isDailyProductionReport) {
      this.runVobDailyProductionReport();
    } else if (this.isQualityReport) {
      this.runVobQualityReport();
    } else if (this.isCallTimeReport) {
      this.runVobCallTimeReport();
    } else if (this.isTATReport) {
      this.runVobTATReport();
    } else if (this.isSpecialistBreakReport) {
      this.runVobSpecialistBreakReport();
    } else if (this.isVobVolumeReport) {
      this.runVobVolumeReport();
    } else if (this.isReAssignReport) {
      this.runVobReAssignReport();
    } else if (this.isMissingInformationReport) {
      this.runVobMissingInformationReport();
    } else if (this.isFacilityPayerReport) {
      this.runVobFacilityPayerReport();
    } else if (this.isSpecialistPerformanceReport) {
      this.runVobSpecialistPerformanceReport();
    }
  }

  //VOB Daily Production Report
  async runVobDailyProductionReport() {
    let requestModel = this.getReportRequestModel();
    if (requestModel == null)
      return;

    await lastValueFrom(this._commonVobReportService.getVobDailyProductionReportData(requestModel)).then((response) => {
      if (response.apiStatus) {
        this._commonPageService.clearGroupPaginationListDataCommon();
        this._commonPageService.setGroupPaginationListDataCommon(response.apiData, response.apiData.length);
        this.processData();
      }
      this.filterPopup = false;
    });
  }

  //Vob Quality Report
  async runVobQualityReport() {
    let requestModel = this.getReportRequestModel();
    if (requestModel == null)
      return;

    await lastValueFrom(this._commonVobReportService.getVobQualityReportData(requestModel)).then((response) => {
      if (response.apiStatus) {
        this._commonPageService.clearGroupPaginationListDataCommon();
        this._commonPageService.setGroupPaginationListDataCommon(response.apiData, response.apiData.length);
        this.processData();
      }
      this.filterPopup = false;
    });
  }

  //Vob Call Metrics Report
  async runVobCallTimeReport() {
    let requestModel = this.getReportRequestModel();
    if (requestModel == null)
      return;

    await lastValueFrom(this._commonVobReportService.getVobCallTimeReportData(requestModel)).then((response) => {
      if (response.apiStatus) {
        this._commonPageService.clearGroupPaginationListDataCommon();
        this._commonPageService.setGroupPaginationListDataCommon(response.apiData, response.apiData.length);
        this.processData();
      }
      this.filterPopup = false;
    });
  }

  //Vob TAT Report
  async runVobTATReport() {
    let requestModel = this.getReportRequestModel();
    if (requestModel == null)
      return;

    await lastValueFrom(this._commonVobReportService.getVobTatMissing(requestModel)).then((response) => {
      if (response.apiStatus) {
        this._commonPageService.clearGroupPaginationListDataCommon();
        this._commonPageService.setGroupPaginationListDataCommon(response.apiData, response.apiData.length);
        this.processData();
      }
      this.filterPopup = false;
    });
  }

  //Vob Specialist Break Report
  async runVobSpecialistBreakReport() {
    let requestModel = this.getReportRequestModel();
    if (requestModel == null)
      return;

    await lastValueFrom(this._commonVobReportService.getVobSpecialistBreak(requestModel)).then((response) => {
      if (response.apiStatus) {
        this._commonPageService.clearGroupPaginationListDataCommon();
        this._commonPageService.setGroupPaginationListDataCommon(response.apiData, response.apiData.length);
        this.processData();
      }
      this.filterPopup = false;
    });
  }

  //VOB Volume Report
  async runVobVolumeReport() {
    let requestModel = this.getReportRequestModel();
    if (requestModel == null)
      return;

    await lastValueFrom(this._commonVobReportService.getVobVolumeReport(requestModel)).then((response) => {
      if (response.apiStatus) {
        this._commonPageService.clearGroupPaginationListDataCommon();
        this._commonPageService.setGroupPaginationListDataCommon(response.apiData, response.apiData.length);
        this.processData();
      }
      this.filterPopup = false;
    });
  }

  //VOB ReAssignment Report
  async runVobReAssignReport() {
    let requestModel = this.getReportRequestModel();
    if (requestModel == null)
      return;

    await lastValueFrom(this._commonVobReportService.getVobReAssignReport(requestModel)).then((response) => {
      if (response.apiStatus) {
        this._commonPageService.clearGroupPaginationListDataCommon();
        this._commonPageService.setGroupPaginationListDataCommon(response.apiData, response.apiData.length);
        this.processData();
        if (this.isDailyProductionReport) {
          this.runVobDailyProductionReport();
        } else if (this.isQualityReport) {
          this.runVobQualityReport();
        } else if (this.isCallTimeReport) {
          this.runVobCallTimeReport();
        } else if (this.isTATReport) {
          this.runVobTATReport();
        } else if (this.isSpecialistBreakReport) {
          this.runVobSpecialistBreakReport();
        } else if (this.isVobVolumeReport) {
          this.runVobVolumeReport();
        }
        this.filterPopup = false;
      }
    });
  }


  //VOB ReAssignment Report
  async runVobMissingInformationReport() {
    let requestModel = this.getReportRequestModel();
    if (requestModel == null)
      return;

    await lastValueFrom(this._commonVobReportService.getVobMissingInformationReport(requestModel)).then((response) => {
      if (response.apiStatus) {
        this._commonPageService.clearGroupPaginationListDataCommon();
        this._commonPageService.setGroupPaginationListDataCommon(response.apiData, response.apiData.length);
        this.processData();
      }
      this.filterPopup = false;
    });
  }

  //Facility Payer Report
  async runVobFacilityPayerReport() {
    let requestModel = this.getReportRequestModel();
    if (requestModel == null)
      return;

    await lastValueFrom(this._commonVobReportService.getVobFacilityPayerReport(requestModel)).then((response) => {
      if (response.apiStatus) {
        this._commonPageService.clearGroupPaginationListDataCommon();
        this._commonPageService.setGroupPaginationListDataCommon(response.apiData, response.apiData.length);
        this.processData();
      }
      this.filterPopup = false;
    });
  }
  
  //Specialist Performance Report
  async runVobSpecialistPerformanceReport() {
    let requestModel = this.getReportRequestModel();
    if (requestModel == null)
      return;

    await lastValueFrom(this._commonVobReportService.getVobSpecialistPerformanceReport(requestModel)).then((response) => {
      if (response.apiStatus) {
        this._commonPageService.clearGroupPaginationListDataCommon();
        this._commonPageService.setGroupPaginationListDataCommon(response.apiData, response.apiData.length);
        this.processData();
      }
      this.filterPopup = false;
    });
  }

  getDateCalculation(event: any) {
    if (event == "Last Year") {
      this.showCalender = false;
      this.range.start = this.coreHelperService.getLastYearStartDate();
      this.range.end = this.coreHelperService.getLastYearEndDate();
    }
    if (event == "Last Week") {
      this.showCalender = false;
      this.range.start = this.coreHelperService.getLastWeekStartDate();
      this.range.end = this.coreHelperService.getLastWeekEndDate();
    }
    if (event == "Last Month") {
      this.showCalender = false;
      this.range.start = this.coreHelperService.getLastMonthStartDate();
      this.range.end = this.coreHelperService.getLastMonthEndDate();
    }
    if (event == "This Week") {
      this.showCalender = false;
      this.range.start = this.coreHelperService.getWeekStartDate();
      this.range.end = this.coreHelperService.getWeekEndDate();
    }
    if (event == "This Month") {
      this.showCalender = false;
      this.range.start = this.coreHelperService.getMonthStartDate();
      this.range.end = this.coreHelperService.getMonthEndDate();
    }
    if (event == "This Year") {
      this.showCalender = false;
      this.range.start = this.coreHelperService.getYearStartDate();
      this.range.end = this.coreHelperService.getYearEndDate();
    }
    if (event == "Custom") {
      this.showCalender = true;
      this.range.start = new Date();
      this.range.end = new Date();
    }
  }

  // Tabel LIST
  public filterlistItems: Array<string> = [
    "Custom",
    "This Week",
    "This Month",
    "Last Week",
    "Last Month",
    "This Year",
    "Last Year",
  ];

  // Modal Start
  public filterPopup = false;
  public facility = false;

  public filterClose() {
    this.filterPopup = false;
    this.selectedFacilityPayerId = DynamicListData.FacilityPayerList[0].value;
  }

  public filterOpen() {
    this.filterPopup = true;
  }

  public facilityOpen() {
    this.facility = true;
  }

  public facilityClose() {
    this.facility = false;
  }

  public carrierContent(args: LegendLabelsContentArgs): string {
    return args.dataItem.carrierValue
  }

  public dollarCount(args: LegendLabelsContentArgs): string {
    return "$" + formatNumber(args.dataItem.weekValue)
  }

  public getFacilityForFilter() {
    this.selectFacilityList = [];
    let facility: any = { 'facilityId': this.coreHelperService.getFacilityId() }
    this._reportService.getFacilityForFilter(facility).subscribe(response => {
      if (response.apiStatus) {
        this.selectFacilityList = response.apiData;
        this.selectedFacility = this.selectFacilityList;
        this.getSpecialistForFilter();
        this.getPayerForFilter();
      }
    });
  }

  async getPayerForFilter() {
    this.selectPayerList = [];
    let dropdownListRequestModel: DropdownListRequestModel = {
      type: DropdownType.Carrier
    };
    await lastValueFrom(this._administrationService.getDataForDropdownList(dropdownListRequestModel)).then((response) => {
      if (response.apiStatus === true) {
        this.selectPayerList = response.apiData;
        this.selectedPayer = this.selectPayerList;
      }
    });
  }

  async getSpecialistForFilter() {
    this.vobSpecialistList = [];
    await lastValueFrom(this._userManagementService.getDepartmentwiseUser(5)).then((response) => {
      if (response.apiStatus) {
        this.vobSpecialistList = response.apiData;
        this.selectedVobSpecialist = this.vobSpecialistList;
        this.runReport();
      }
    });
  }

  //#region Sorting Grid Data
  sortChangeVOBReport(sort: SortDescriptor[]): void {
    this._commonPageService.commonState.sort = sort;
    if (this.isDailyProductionReport) {
      this.runVobDailyProductionReport();
    } else if (this.isQualityReport) {
      this.runVobQualityReport();
    } else if (this.isCallTimeReport) {
      this.runVobCallTimeReport();
    } else if (this.isTATReport) {
      this.runVobTATReport();
    } else if (this.isSpecialistBreakReport) {
      this.runVobSpecialistBreakReport();
    } else if (this.isVobVolumeReport) {
      this.runVobVolumeReport();
    } else if (this.isReAssignReport) {
      this.runVobReAssignReport();
    } else if (this.isMissingInformationReport) {
      this.runVobMissingInformationReport();
    } else if (this.isFacilityPayerReport) {
      this.runVobFacilityPayerReport();
    } else if (this.isSpecialistPerformanceReport) {
      this.runVobSpecialistPerformanceReport();
    }
  }
  //#endregion
  //#region Paging Grid Data
  pageChangeVOBReport(event: PageChangeEvent): void {
    this._commonPageService.commonState.take = event.take;
    this._commonPageService.commonState.skip = event.skip;
  }
  //#endregion
  //#region Filter Grid Data
  filterChangeVOBReport(filter: CompositeFilterDescriptor): void {
    this._commonPageService.commonState.filter = filter;
    if (this.isDailyProductionReport) {
      this.runVobDailyProductionReport();
    } else if (this.isQualityReport) {
      this.runVobQualityReport();
    } else if (this.isCallTimeReport) {
      this.runVobCallTimeReport();
    } else if (this.isTATReport) {
      this.runVobTATReport();
    } else if (this.isSpecialistBreakReport) {
      this.runVobSpecialistBreakReport();
    } else if (this.isVobVolumeReport) {
      this.runVobVolumeReport();
    } else if (this.isReAssignReport) {
      this.runVobReAssignReport();
    } else if (this.isMissingInformationReport) {
      this.runVobMissingInformationReport();
    } else if (this.isFacilityPayerReport) {
      this.runVobFacilityPayerReport();
    } else if (this.isSpecialistPerformanceReport) {
      this.runVobSpecialistPerformanceReport();
    }
  }

  processData() {
    this._commonPageService.groupPaginationListDataCommon = {
      data:
        filterBy(this._commonPageService.groupPaginationListDataCommon.data, this._commonPageService.commonState.filter),
      total:
        filterBy(this._commonPageService.groupPaginationListDataCommon.data, this._commonPageService.commonState.filter).length
    }
    this._commonPageService.groupPaginationListDataCommon = {
      data:
        orderBy(this._commonPageService.groupPaginationListDataCommon.data, this._commonPageService.commonState.sort),
      total:
        orderBy(this._commonPageService.groupPaginationListDataCommon.data, this._commonPageService.commonState.sort).length
    };
  }
  //#endregion
  //#region Clear Grid Data
  public clearFilter() {
    this._commonPageService.clearCommonState();
    this._commonPageService.clearGroupPaginationListDataCommon();
    this.range.start = this.coreHelperService.getMonthStartDate().toISOString();
    this.range.end = this.coreHelperService.getMonthEndDate().toISOString();
    this.selectedFacilityPayerId = DynamicListData.FacilityPayerList[0].value;
    this.getFacilityForFilter();
    this.selectedMonthss = "This Month";
  }
  //#endregion

  public exportToPdf() {
    let grid: GridComponent;
    if (this.isDailyProductionReport && this.dailyProductionReportGrid != undefined) {
      grid = this.dailyProductionReportGrid;
    }
    else if (this.isQualityReport && this.qualityReportGrid != undefined) {
      grid = this.qualityReportGrid;
    }
    else if (this.isCallTimeReport && this.callTimeReportGrid != undefined) {
      grid = this.callTimeReportGrid;
    }
    else if (this.isTATReport && this.tatReportGrid != undefined) {
      grid = this.tatReportGrid;
    }
    else if (this.isSpecialistBreakReport && this.specialistBreakReportGrid != undefined) {
      grid = this.specialistBreakReportGrid;
    }
    else if (this.isVobVolumeReport && this.vobVolumeReportGrid != undefined) {
      grid = this.vobVolumeReportGrid;
    }
    else if (this.isReAssignReport && this.vobVolumeReportGrid != undefined) {
      grid = this.vobVolumeReportGrid;
    }
    else if (this.isMissingInformationReport && this.missingInformationReportGrid != undefined) {
      grid = this.missingInformationReportGrid;
    }
    else if (this.isFacilityPayerReport && this.facilityPayerReportGrid != undefined) {
      grid = this.facilityPayerReportGrid;
    }
    else if (this.isSpecialistPerformanceReport && this.specialistPerformanceReportGrid != undefined) {
      grid = this.specialistPerformanceReportGrid;
    }
    if (grid != undefined)
      grid.saveAsPDF();
  }

  public exportToExcel() {
    let grid: GridComponent;
    if (this.isDailyProductionReport && this.dailyProductionReportGrid != undefined) {
      grid = this.dailyProductionReportGrid;
    }
    else if (this.isQualityReport && this.qualityReportGrid != undefined) {
      grid = this.qualityReportGrid;
    }
    else if (this.isCallTimeReport && this.callTimeReportGrid != undefined) {
      grid = this.callTimeReportGrid;
    }
    else if (this.isTATReport && this.tatReportGrid != undefined) {
      grid = this.tatReportGrid;
    }
    else if (this.isSpecialistBreakReport && this.specialistBreakReportGrid != undefined) {
      grid = this.specialistBreakReportGrid;
    }
    else if (this.isVobVolumeReport && this.vobVolumeReportGrid != undefined) {
      grid = this.vobVolumeReportGrid;
    }
    else if (this.isMissingInformationReport && this.missingInformationReportGrid != undefined) {
      grid = this.missingInformationReportGrid;
    }
    else if (this.isFacilityPayerReport && this.facilityPayerReportGrid != undefined) {
      grid = this.facilityPayerReportGrid;
    }
    else if (this.isSpecialistPerformanceReport && this.specialistPerformanceReportGrid != undefined) {
      grid = this.specialistPerformanceReportGrid;
    }
    if (grid != undefined)
      grid.saveAsExcel();
  }

  showVobDetailedHistoryByVobId(vobId: number = 0, requestId: number = 0, paramHistoryId: number = 0) {
    this.getVobUpdateHistory(vobId, requestId, paramHistoryId);
  }

  async getVobUpdateHistory(vobId: number = 0, requestId: number = 0, paramHistoryId: number = 0) {
    let requestModel: any = {
      vobId: vobId,
      requestId: requestId,
      historyId: paramHistoryId,
    }
    await lastValueFrom(this._vobService.getVobUpdateHistoryById(requestModel)).then((response) => {
      if (response.apiStatus) {
        this.showVobDetailHistory = true;
        this.detailedHistoryList = response.apiData;
      }
    });
  }

}